export interface Languages {
  name: string;
  code: string;
  flag: string;
}

export const languages: Languages[] = [
  {
    name: "English AU",
    code: "en-AU",
    flag: "https://twemoji.maxcdn.com/v/13.1.0/72x72/1f1ed-1f1f2.png"
  },
  {
    name: "English UK",
    code: "en-GB",
    flag: "https://twemoji.maxcdn.com/v/13.1.0/72x72/1f1ec-1f1e7.png"
  },
  {
    name: "English US",
    code: "en-US",
    flag: "https://twemoji.maxcdn.com/v/13.1.0/72x72/1f1fa-1f1f8.png"
  },
  {
    name: "Ukrainian",
    code: "uk-UA",
    flag: "https://em-content.zobj.net/thumbs/120/twitter/322/flag-ukraine_1f1fa-1f1e6.png"
  },
];
